module.exports = __webpack_public_path__ + "static/GE_Module_3-f70ccd68ada1dcc1c0a53936e80a1078.png";